// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/distribution/distribution.proto" (package "mlmbox.client.distribution", syntax proto3)
// tslint:disable
import { Distribution_Holder } from "../../types/distribution.ts";
import { Distribution_State } from "../../types/distribution.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.client.distribution.SignatureMessageResponse
 */
export interface SignatureMessageResponse {
    /**
     * @generated from protobuf field: string message = 1;
     */
    message: string;
    /**
     * @generated from protobuf field: uint32 expired_at = 2;
     */
    expiredAt: number;
}
/**
 * @generated from protobuf message mlmbox.client.distribution.AttachSignedMessageRequest
 */
export interface AttachSignedMessageRequest {
    /**
     * @generated from protobuf field: string message = 1;
     */
    message: string;
    /**
     * @generated from protobuf field: string signature = 2;
     */
    signature: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class SignatureMessageResponse$Type extends MessageType<SignatureMessageResponse> {
    constructor() {
        super("mlmbox.client.distribution.SignatureMessageResponse", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expired_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<SignatureMessageResponse>): SignatureMessageResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = "";
        message.expiredAt = 0;
        if (value !== undefined)
            reflectionMergePartial<SignatureMessageResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SignatureMessageResponse): SignatureMessageResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message */ 1:
                    message.message = reader.string();
                    break;
                case /* uint32 expired_at */ 2:
                    message.expiredAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SignatureMessageResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string message = 1; */
        if (message.message !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        /* uint32 expired_at = 2; */
        if (message.expiredAt !== 0)
            writer.tag(2, WireType.Varint).uint32(message.expiredAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.distribution.SignatureMessageResponse
 */
export const SignatureMessageResponse = new SignatureMessageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttachSignedMessageRequest$Type extends MessageType<AttachSignedMessageRequest> {
    constructor() {
        super("mlmbox.client.distribution.AttachSignedMessageRequest", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "signature", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AttachSignedMessageRequest>): AttachSignedMessageRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = "";
        message.signature = "";
        if (value !== undefined)
            reflectionMergePartial<AttachSignedMessageRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttachSignedMessageRequest): AttachSignedMessageRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message */ 1:
                    message.message = reader.string();
                    break;
                case /* string signature */ 2:
                    message.signature = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttachSignedMessageRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string message = 1; */
        if (message.message !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        /* string signature = 2; */
        if (message.signature !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.signature);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.distribution.AttachSignedMessageRequest
 */
export const AttachSignedMessageRequest = new AttachSignedMessageRequest$Type();
/**
 * @generated ServiceType for protobuf service mlmbox.client.distribution.Distribution
 */
export const Distribution = new ServiceType("mlmbox.client.distribution.Distribution", [
    { name: "Info", options: {}, I: Empty, O: Distribution_State },
    { name: "GetSignatureMessage", options: {}, I: Empty, O: SignatureMessageResponse },
    { name: "Web3AddressAttachSigned", options: {}, I: AttachSignedMessageRequest, O: Distribution_State },
    { name: "Web3AddressDetach", options: {}, I: Empty, O: Distribution_State },
    { name: "HolderInfo", options: {}, I: Empty, O: Distribution_Holder }
]);
